<template>
  <div style="padding: 10px;" v-if="stats">
    <p><b>Total:</b> {{total}}</p>
    <p
      v-for="item of stats"
      :key="item.Date"
    >
      <b>{{item.Date}}:</b> {{item.Count}}
    </p>
  </div>
</template>
<script>
import apiDtouch from '@/services/apiDtouch'
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    total: 0,
    stats: null,
    loading: false,
  }),
  watch: {
    id () {
      this.stats = null
      this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    async handleGetData () {
      try {
        this.stats= null
        this.loading = true
        if (this.id) {
          this.stats = await new Promise((resolve, reject) => apiDtouch.getAll(`v1/private/pop-up/${this.id}/stats`)
            .then(response => {
              let total = 0
              response = response.map(item => {
                total += item.Count
                item.Date = `${item.Year}/${item.Month}`
                return item
              })
              this.total = total
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
            .finally(() => {
              this.loading = false
            }))
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

